// components/LoaderModal.jsx
import { Weight } from 'lucide-react';
import React, { useEffect } from 'react';

const LoaderModal = ({ message = 'Loading...', isOpen, onClose }) => {
  // Close the modal when API call completes (isOpen changes to false)
  useEffect(() => {
    if (!isOpen) {
      onClose?.();
    }
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <p style={styles.message}>⏳ {message}</p>
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: 'fixed',
    top: 0, left: 0,
    width: '100%', height: '100%',
    backgroundColor: 'rgba(0,0,0,0.3)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
  },
  modal: {
    backgroundColor: '#fff',
    padding: '2rem',
    borderRadius: '10px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
  },
  spinner: {
    border: '6px solid #f3f3f3',
    borderTop: '6px solid #07b1b0',
    borderRadius: '50%',
    width: '40px',
    height: '40px',
    animation: 'spin 1s linear infinite',
    marginBottom: '1rem',
  },
  message: {
    fontSize: '16px',
    color: '#333',
    fontWeight: 'bold',
  },
};

export default LoaderModal;
